





















































import { Component, Inject, Prop, Vue } from 'vue-property-decorator'
import { Referral } from '@/api/model/referral'

@Component
export default class ReferralDetails extends Vue {
    @Inject() reloadReferral: () => Promise<void>
    @Prop({ required: true }) readonly referral!: Referral

    get canEdit(): boolean {
        if (!this.$currentCompany || !this.referral || !this.referral.assignedToBranch) {
            return false
        }

        return this.$currentCompany.id === this.referral.assignedToBranch.company.id
    }

    get isEditable(): boolean {
        if (!this.referral || ['processed', 'closed'].includes(this.referral.status)) {
            return false
        }

        return true
    }

    get hasFinancialData(): boolean {
        return this.referral.orderValue !== null
            || this.referral.leadCommission !== null
    }

    get isOrdersEnabled(): boolean {
        return this.$currentCompany.orderSettings
            && this.$currentCompany.orderSettings.enabled
    }

    get shouldShowFinancialTab(): boolean {
        // Show if we have values
        if (this.hasFinancialData) {
            return true
        }

        // Hide if no values and orders are enabled.
        if (this.isOrdersEnabled) {
            return false
        }

        return true
    }

    get widgetAvatarSvg(): string[] {
        return [
            'brunette-circle',
            'blond-circle',
            'sylvana-circle',
        ]
    }
}

